module.exports = __webpack_public_path__ + "static/media/achieve.83a0b3de.jpg";